/**
 * @generated SignedSource<<36f577a193e18b1fe13313d31422e9fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditAccomodationHotel_package$data = {
  readonly hotel: {
    readonly descriptionText: {
      readonly activeBlock: {
        readonly data: string | null;
      } | null;
    } | null;
    readonly destination: string | null;
    readonly id: string;
    readonly mainMedia: {
      readonly " $fragmentSpreads": FragmentRefs<"MediaThumb_media">;
    } | null;
    readonly name: string;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "PackageEditAccomodationHotel_package";
};
export type PackageEditAccomodationHotel_package$key = {
  readonly " $data"?: PackageEditAccomodationHotel_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditAccomodationHotel_package">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditAccomodationHotel_package",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Hotel",
      "kind": "LinkedField",
      "name": "hotel",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "destination",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Media",
          "kind": "LinkedField",
          "name": "mainMedia",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "MediaThumb_media"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Text",
          "kind": "LinkedField",
          "name": "descriptionText",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TextBlock",
              "kind": "LinkedField",
              "name": "activeBlock",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "data",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": null
};
})();

(node as any).hash = "8b210a5a39403093ff30907573d43588";

export default node;
